import script from "./PersoenlicheDaten.vue?vue&type=script&setup=true&lang=js"
export * from "./PersoenlicheDaten.vue?vue&type=script&setup=true&lang=js"

import "./PersoenlicheDaten.vue?vue&type=style&index=0&id=7c239c08&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c239c08"]])

export default __exports__